import { AbstractControl } from "@angular/forms";

export const validateRequestForm = (
  control: AbstractControl
): { [key: string]: boolean } => {
  const endDateTime = control.value.endDateTime;
  const startDateTime = control.value.startDateTime;
  if (!endDateTime && !startDateTime) return null;
  if (endDateTime !== '' && endDateTime <= startDateTime) {
    return { endDateLessThanStartDateTime: true };
  }
}



// WEBPACK FOOTER //
// /app/src/app/modules/request/request-form/validator.ts